import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "../../config.json";
import { getApp } from "firebase/app";

export function adminGetAllBundledTransportsRequest(cursorBundleId) {
    let data = {};
    if (cursorBundleId !== "") {
        data = {
            cursor_bundled_id: cursorBundleId,
        };
    }
    log(data);
    log("service name: " + config.adminGetAllBundledTransportsRequest)
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminGetAllBundledTransportsRequest);
    return allTransports(data);
}

export function adminFindBundledTransports(orderNumber) {
    let data = { order_number: orderNumber };
    log(data);
    log("service name: " + config.adminFindBundledTransports)
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminFindBundledTransports);
    return allTransports(data);
}

export function adminEditBundledTransportsPrice(bundleId, bundleReceivablePrice, transports) {
    let data = {
        bundle_id: bundleId,
        bundle_price: bundleReceivablePrice,
        transports
    }

    log(data);
    log("service name: " + config.adminEditBundledTransportsPrice)
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminEditBundledTransportsPrice);
    return allTransports(data);
}
export function adminCancelBundledTransports(bundleId) {
    let data = {
        bundle_id: bundleId,
    }

    log(data);
    log("service name: " + config.adminCancelBundledTransports)
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminCancelBundledTransports);
    return allTransports(data);
}

export function adminGetRiderInfo(riderId) {
    const data = { rider_user_id: riderId };
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    log(data);
    log("service name: " + config.adminGetRiderInfo)

    const findTransport = httpsCallable(functions, config.adminGetRiderInfo);
    return findTransport(data);
}
export function adminBundledAssignToNewRider(riderId, bundleId) {
    const data = {
        rider_user_id: riderId, bundle_id: bundleId,
    };
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    log(data);
    log("service name: " + config.adminBundledAssignToNewRider)

    const findTransport = httpsCallable(functions, config.adminBundledAssignToNewRider);
    return findTransport(data);
}

export function adminGetOnlineRidersForAssignment(
    searchRiderLimitOnlineStateTime,
    originLat,
    originLng,
    walking,
    cycling,
    riding,
    driving
) {
    const data = {
        search_rider_limit_online_state_time: searchRiderLimitOnlineStateTime,
        origin_lat: Number(originLat),
        origin_lng: Number(originLng),
        walking: walking,
        cycling: cycling,
        riding: riding,
        driving: driving,
    };
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    log(data);
    log("service name: " + config.adminGetOnlineRidersForAssignment)
    const asignTransport = httpsCallable(
        functions,
        config.adminGetOnlineRidersForAssignment
    );
    return asignTransport(data);
}